// extracted by mini-css-extract-plugin
export default {"page":"MainPage_page__XcoUs","loader":"MainPage_loader__Tj2VP","error":"MainPage_error__jbr90"};